import React from 'react';
import { View, Text, ActivityIndicator, StyleSheet, Image } from 'react-native';
import { useTheme } from '../context/ThemeContext';

const splashImage = require('../../assets/splash.png');

type Props = {
  message?: string;
  showBrand?: boolean;
};

/** Full-screen loading with very dark green background and brand mark. */
const AppLoadingScreen = ({ message, showBrand = true }: Props) => {
  const { colors } = useTheme();

  return (
    <View style={[styles.root, { backgroundColor: colors.loading.background }]}>
      {showBrand ? (
        <Image
          source={splashImage}
          style={styles.splashImage}
          resizeMode="contain"
          accessibilityLabel="GoalMint"
        />
      ) : null}
      <ActivityIndicator
        size="large"
        color={colors.accent.mint}
        style={showBrand ? styles.spinner : undefined}
      />
      {message ? (
        <Text style={[styles.message, { color: colors.text.onNav }]}>{message}</Text>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  splashImage: {
    width: '100%',
    maxWidth: 400,
    height: 280,
    marginBottom: 8,
  },
  spinner: {
    marginTop: 24,
  },
  message: {
    marginTop: 10,
    fontSize: 15,
  },
});

export default AppLoadingScreen;
